import { render, staticRenderFns } from "./OAuth.vue?vue&type=template&id=a27eff4c&scoped=true&"
import script from "./OAuth.vue?vue&type=script&lang=js&"
export * from "./OAuth.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/authen.css?vue&type=style&index=0&id=a27eff4c&scoped=true&lang=css&"
import style1 from "./OAuth.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27eff4c",
  null
  
)

export default component.exports